/* eslint-disable max-len */
import { CONTENT } from '@bitComponents/unifiedComponents/Stopper';
import {
  BUTTON_WIDTH,
  BUTTON_HEIGHT,
  BUTTON_COLOR,
} from '@bitComponents/unifiedComponents/Button';
import { USER_TYPE } from '../../../../bitConstants/constants';
import { URLS } from '../../errorTextsConstants';

export const getErrorToPrint = ( goToC2C ) => {
  return {
    common: {
      INCOMPATIBLE_PRODUCT_BY_ZONE: {
        errorType: CONTENT.ERROR_ALERT,
        errorInfo: {
          buttons: [
            {
              label: 'Ir al listado de Internet',
              link: URLS.BAF_TARIFF_LIST,
              desktopProps: {
                size: {
                  w: BUTTON_WIDTH.LIQUID_DOPPED,
                  h: BUTTON_HEIGHT.REGULAR,
                },
              },
              color: BUTTON_COLOR.BLUE,
            },
          ],
          title: 'No es posible generar tu pedido',
          msg: [
            'El código postal de la dirección de instalación no coincide con el que nos facilitaste al iniciar la compra.',
            'Lamentablemente este producto no está disponible en tu municipio.',
          ],
          errorName: 'pedido en curso',
        },
      },
      INCOMPATIBLE_PRODUCT: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: "Producto incompatible",
          msg: [
            "El producto seleccionado es incompatible con tus productos actuales.",
            "Es necesario tener contratado un miMovistar Autónomos para poder contratar este producto",
          ],
          errorName: "producto incompatible",
        },
      },
      MAX_CARDINALITY_REACHED: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: 'Producto ya contratado',
          msg: ['Actualmente ya tienes contratado este producto'],
          errorName: 'produco ya contratado - cardinalidad superada',
        },
      },
    },
    [`user_${USER_TYPE.TELCO}`]: {
    },
    [`user_${USER_TYPE.OPEN}`]: {
    },
  }
};
